module.exports = __webpack_public_path__ + "static/media/S4N6-1.f188e509.svg";